import { render, staticRenderFns } from "./Voucher-Search.vue?vue&type=template&id=f70d7b64&scoped=true&"
import script from "./Voucher-Search.vue?vue&type=script&lang=js&"
export * from "./Voucher-Search.vue?vue&type=script&lang=js&"
import style0 from "./Voucher-Search.vue?vue&type=style&index=0&id=f70d7b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70d7b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f70d7b64')) {
      api.createRecord('f70d7b64', component.options)
    } else {
      api.reload('f70d7b64', component.options)
    }
    module.hot.accept("./Voucher-Search.vue?vue&type=template&id=f70d7b64&scoped=true&", function () {
      api.rerender('f70d7b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6rphBAVPYny/JS/comp/Voucher-Search.vue"
export default component.exports